import { Box, Button, Stack, Typography } from "@mui/material";
import { T } from "../../util/t";
import { Add, Remove } from "@mui/icons-material";
import { PriceDescriptions } from "../registration/selectOptionsField/PriceDescriptions";
import { SimpleList } from "../lists/SimpleList";
import { formatPrice } from "utils/utils";
import { AccordionItem } from "../accordions/AccordionItem";
import { Link } from "react-router-dom";
import { useCurrentUser } from "components/providers/CurrentUserProvider";
import { useIsMobile } from "hooks/useIsMobile";
import { OpenMemberships } from "./OpenMemberships";

export const MembershipSignUp = ({ series, expanded = false, federatedOrganisationTerm, openAccordionPanel }) => {
    const { loaded, currentUser } = useCurrentUser();
    const isLoggedIn = loaded && currentUser;
    const isMobile = useIsMobile();

    const joinButton = <Button variant="contained" fullWidth component={Link} to={`/${series.organisation.shortName}/series/${series.id}/sign-on`}><T>{isLoggedIn ? "Join now" : "Log in and join"}</T></Button>;
    const getPrice = divisionId => series.options.divisions?.find(d => d.id === divisionId)?.price != null ?
        series.options.divisions?.find(d => d.id === divisionId)?.price : series.options.defaultDivisionPrice;

    return (
        <AccordionItem
            id={series.id}
            expanded={expanded}
            onChange={openAccordionPanel}
            variant={series.options.federatedMembership && expanded && "secondary"}
            summary={(
                <Stack spacing={1} direction="row" alignItems="center">
                    <Box component={expanded ? Remove : Add} color={expanded ? "primary.main" : "text.secondary"} fontSize="large" />
                    {series.parentSeries
                        ? <Stack>
                            <Typography variant="button3">{series.organisation.name}</Typography>
                            <Typography variant="subtitle2">{series.name}</Typography>
                        </Stack>
                        : <Typography variant="subtitle2">{series.name}</Typography>}
                </Stack>
            )}
            expandIcon={!series.options.federatedMembership && !isMobile && expanded && joinButton}
            disableRotation
        >
            {series.options.federatedMembership
                ? <>
                    <Typography marginBottom={2}>
                        <T federatedOrganisationTerm={federatedOrganisationTerm}>select_your_home_federated_term</T>
                    </Typography>
                    <OpenMemberships series={series.childSeries} federatedOrganisationTerm={federatedOrganisationTerm} />
                </>
                : <>
                    {isMobile && joinButton}
                    <Typography variant="subtitle2" marginTop={isMobile ? 4 : 0}><T>Options</T></Typography>
                    <Typography color="text.secondary" marginBottom={2}>
                        <PriceDescriptions
                            registrationOptions={series.registrationOptions}
                            paymentOptions={series.options}
                            isSeriesRegistration
                            totalDivisions={series.membershipDivisions.length}
                        />
                    </Typography>

                    <SimpleList hideLastBorder>
                        {series.membershipDivisions.map(division => ({
                            title: division.name,
                            description: formatPrice(getPrice(division.id), series.options.currency)
                        }))}
                    </SimpleList>
                </>}
        </AccordionItem>
    );
};
